module.exports = __webpack_public_path__ + "img/6.35fb1047.png";